import { Grid, Typography, Box } from '@mui/material';
import ordenador from '../../../../assets/ordenador.png';

const Fourth = () => {
  return (
    <>
    <Typography variant="h3" sx={{ fontSize: { xs: '1.5rem', md: '3rem' }, fontWeight:'bold',textAlign:'center',marginTop:'50px',color:"gray" }}>
      Monitoreo de carga en tiempo real 
    </Typography>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '0 auto',
        padding: '0 50px',
      }}
    >
      <Grid
        container
        spacing={{ xs: 1, md: 20 }}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'center', md: 'left' } }}> 
          
          <Typography variant="body2" sx={{ fontSize: { xs: '1rem', md: '1.5rem' }, mt: 2, fontWeight:'bold' }}>
          Supervisa las condiciones de la carga y protege tus activos frente a pérdidas.
          </Typography>
          <Typography variant="body2" sx={{ fontSize: { xs: '1rem', md: '1.5rem' }, mt: 2 }}>
          Con Globspot, puedes monitorear la temperatura y las condiciones de tu carga en todo momento, evitando daños y pérdidas.
          </Typography>
        </Grid>

        <Grid item xs={12} md={4}>
          <img
            src={ordenador}
            alt="Descripción de la imagen"
            style={{
              width: '100%',  
              maxWidth: '500px',  
              height: 'auto',
            }}
          />
        </Grid>
      </Grid>
    </Box>
    </>
  );
};

export default Fourth;
